import { HATCH_APP_ROUTE } from 'root/stores/routes/APP_URLS';
import { getImpersonationSession } from 'utils/impersonationSession';

export default {
  // API wrapper for handling network requests
  getExtraArgs: (store) => {
    return {
      request: (method, args) => {
        return new Promise((resolve, reject) => {
          // uncomment if we need to add sockets
          // const socketID = store.selectSocketId()
          const { apiKey = '' } = getImpersonationSession();
          method({
            ...(args || {}),
            headers: { /* socketID, */ 'X-API-KEY': apiKey },
          })
            .then((res) => {
              // get status code if it exists
              const statusCode = res?.statusCode ?? 500;

              // resolve response body
              if (statusCode < 400) return resolve(res?.body?.data ?? null);

              // get the error object
              const errorBody = res?.error ?? null;

              // if 401 (unauthorized) then log them out
              if (statusCode === 401) {
                // reset state
                store.dispatch({ payload: {}, type: 'REPLACE_STATE' });

                // if a user is not logged in, log where they came from to
                // redirect them back to where they came from
                // send the user to the login form
                window.location.replace(
                  `${HATCH_APP_ROUTE}?redirectURL=${window.location.href}`,
                );
              }

              // if there is another error code, reject it
              return reject(errorBody);
            })
            .catch((err) => reject(err));
        });
      },
    };
  },
  name: 'extra-args',
};
